// Cognito usernames are emails here, so compare them ignoring case. Both sides must be present -
// an unknown current user is never "the same" as anyone.
export const isSameUser = (a: string | null | undefined, b: string | null | undefined): boolean =>
  !!a && !!b && a.toLowerCase() === b.toLowerCase();
